import styled from 'styled-components'

export const WidgetContainer = styled.div`
  display: flex;
  align-items: center;
  width: 200px;
  height: 90px;
  border-radius: 100px;
  background-color: #fff;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  button {
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
  }
  @media (max-width: 1200px) {
    height: 72px;
  }
  @media (max-width: 1000px) {
    height: 90px;
    border-radius: 59.5px;
  }
  @media (max-width: 600px) {
    width: 140px;
    height: 63px;
    margin: 5px auto 19px;
  }
  .starSvg {
    :hover {
      fill: #933EC5;
    }
    margin-left: 34px;
    fill: #fff;
    transition: fill .4s ease;
    @media (max-width: 600px) {
      margin-left: 24px;
      width: 35px;
      height: 35px;
    }
  }
  .starsCount {
    margin-left: 20px;
    font-family: StolzlMedium, serif;
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 2px;
    @media (max-width: 600px) {
      margin-left: 14px;
      font-size: 14px;
      line-height: 2.14;
    }
  }
`
